import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { nextTick } from "vue";
const Dashboard = () => import("@/views/Dashboard.vue");
const GetHelp = () => import("@/views/GetHelp.vue");
const Auth = () => import("@/views/Auth.vue");
const AuthHome = () => import("@/views/AuthHome.vue");

// eslint-disable-next-line
const settings = require("@/settings");

const routes: Array<RouteRecordRaw> = [
  {
    path: "/get-help",
    name: "get-help",
    component: GetHelp,
  },
  {
    path: "/dashboard/:page(\\d+)?",
    name: "dashboard",
    component: Dashboard,
  },
  {
    path: "/auth",
    component: Auth,
    children: [
      {
        path: "",
        name: "auth",
        component: AuthHome,
      },
    ],
  },
  {
    path: "/:p(.*)*",
    redirect: {
      name: "get-help",
    },
  },
];

const router = createRouter({
  history: createWebHistory(settings.baseUrl),
  // linkExactActiveClass: 'active',
  linkActiveClass: 'active',
  routes,
});

router.afterEach((t) => {
  nextTick(() => {
    document.title = (t.meta.title as string) || "战疫求助平台";
  });
});

export default router;
